export const stageNames: Record<string, string> = {
  pastRemoval: "Past Removal",
  mapNativeVeg: "Map Native Vegetation",
  summaryReport: "Summary & Report",
};

export const stageIcons: Record<string, string> = {
  pastRemoval: "locationTick",
  mapNativeVeg: "polygonSketch",
  summaryReport: "report",
};

export const removalStages = ["pastRemoval", "mapNativeVeg", "summaryReport"];

export const offsetStages = ["mapNativeVeg", "summaryReport"];
